import request from '@/utils/request'

export function getDictData (dictCodes) {
  return request({
    url: '/admin/sysDict/v1/findByCodes?dictCodes=' + dictCodes.join(','),
    method: 'get'
  })
}

export function invalidDictHash(map) {
  return request({
    url: '/admin/system/dict/invalid-hash',
    method: 'post',
    data: map
  })
}


export function getPage(query) {
  return request({
    url: '/admin/sysDict/v1/findByPage',
    method: 'post',
    data: query
  })
}

export function addObj(obj) {
  return request({
    url: '/admin/sysDict/v1/createSysDict',
    method: 'post',
    data: obj
  })
}

export function getObj(id) {
  return request({
    url: '/admin/system/dict/' + id,
    method: 'get'
  })
}

export function delObj(id) {
  return request({
    url: '/admin/sysDict/v1/delete/' + id,
    method: 'post'
  })
}

export function putObj(obj) {
  return request({
    url: '/admin/sysDict/v1/updateSysDict',
    method: 'post',
    data: obj
  })
}
